import React from 'react';
import './NavBar.css';
import { useIsAuthenticated } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import NavBarAuth from './NavBarAuth';
import LoginPage from './LoginPage';
import useMsalInteractionStatus from '@frontend/AppSettings/hooks/useMsalInteractionStatus';

const NavBar: React.FC = () => {
  const inProgress = useMsalInteractionStatus();
  const isAuthenticated = useIsAuthenticated();

  if (isAuthenticated) {
    return <NavBarAuth></NavBarAuth>;
  } else if (
    inProgress !== InteractionStatus.Startup &&
    inProgress !== InteractionStatus.HandleRedirect
  ) {
    // inProgress check prevents sign-in button from being displayed briefly after returning from a redirect sign-in. Processing the server response takes a render cycle or two
    return <LoginPage></LoginPage>;
  } else {
    return null;
  }
};

export default NavBar;
